import { FC, Fragment, ReactElement, ReactNode } from 'react';
import { IProductRootProps, ProductRoot } from 'mod/product-list/ProductRoot';
import { ProductPicture } from 'mod/product-list/ProductPicture';
import { ProductTitle } from 'mod/product-list/ProductTitle';
import { ProductRate } from 'mod/product-list/ProductRate';
import { ProductPrices } from 'mod/product-list/ProductPrices';
import { ProductAddCart } from 'mod/product-list/ProductAddCart';
import { ProductProgress } from 'mod/product-list/ProductProgress';
import { ProductPoints } from 'mod/product-list/ProductPoints';
import { ProductOptions } from 'mod/product-list/ProductOptions';
import { TListProductElement } from 'mod/product-list/interface';

export type IListProductProps = IProductRootProps & {
    elements?: Array<TListProductElement | string>;
    children?: ReactNode;
    customElements?: Record<string, FC<any>>;
};

function renderElement(
    element: TListProductElement | string,
    elements: Array<TListProductElement | string>,
    customElements?: Record<string, FC<any>>
): ReactElement | null {

    if (customElements?.[element]) {
        const CustomElement = customElements[element];
        return <CustomElement />;
    }

    switch (element) {
        case 'title':
            return <ProductTitle/>;
        case 'rate':
            return <ProductRate/>;
        case 'prices':
            // 同时存在价格和加车时返回连个模块
            if (elements.includes('addCart')) {
                return (
                    <div className={'g-prices-addcart flex'}>
                        <ProductPrices className={'flex-1'}/>
                        <ProductAddCart/>
                    </div>
                );
            }
            return <ProductPrices/>;
        case 'addCart':
            // 同时存在价格和加车时返回 null
            return elements.includes('prices') ? null : <ProductAddCart/>;
        case 'progress':
            return <ProductProgress/>;
        case 'points':
            return <ProductPoints/>;
        case 'options':
            return <ProductOptions/>;
        default:
            return null;
    }
}

export const ListProduct: FC<IListProductProps> = props => {
    const {
        item,
        imageSize,
        className,
        elements = [],
        children,
        customElements,
        ...rootProps
    } = props;

    return (
        <ProductRoot
            item={item}
            className={className}
            imageSize={imageSize}
            {...rootProps}
        >
            {children || (
                <>
                    <ProductPicture/>

                    {elements.length > 0 && (
                        <div className={'g-elements'}>
                            {elements.map((elem, index) => (
                                <Fragment key={`${elem}-${index}`}>
                                    {renderElement(elem, elements, customElements)}
                                </Fragment>
                            ))}
                        </div>
                    )}
                </>
            )}
        </ProductRoot>
    )
};
